/**
 * @description 保單規則 (enum)
 */
export enum PolicyRulesEnum {
  /** 年齡與保額限制 */
  AgeAndAmountLimit = '1',
  /** 密集投保 (非網路投保累計) */
  FrequentlyInsure = '2',
  /** 密集投保 (網路投保累計) */
  FrequentlyInsureCount = '3',
  /** 累計投保保額超過限額 (不限網路投保) */
  AccumulatedAmountExceededLimit = '4',
  /** 七足歲以下喪葬費用限額 */
  Under7FuneralExpenseLimit = '5',
  /** 關懷名單 (黑名單) */
  BlackList = '6',
  /** 洗錢名單 */
  LaunderingList = '7',
  /** 受有監護宣告身份 (被保險人) */
  UnderGuardianship = '8',
  /** 其他身分檢核 (外籍人士) */
  OtherIdentity = '9',
  /** 不承保旅遊地區 */
  NotCoveredTravelArea = '10',
  /** 不保事項 */
  Exclusions = '11',
  /** 受益人關係 */
  BeneficiaryRelationship = '12',
  /** 附加傷害醫療限制 */
  AdditionalInjuryMedicalLimit = '13',
  /** 附加海外突發疾病醫療限制 */
  AdditionalOverseasEmergencyMedicalLimit = '14',
  /** 檢查是否重複 */
  CheckDuplicates = '15'
}
